import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://tripverse.co.uk";

interface SEOProps {
  title: string;
  description: string;
  noindex?: boolean;
}

export const SEO = ({ title, description, noindex }: SEOProps) => {
  const location = useLocation();
  const fullTitle = `TripVerse — ${title}`;
  const url = `${BASE_URL}${location.pathname}${location.search}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};
